import { render, staticRenderFns } from "./BottomAppBar.vue?vue&type=template&id=c6fc6224&scoped=true"
import script from "./BottomAppBar.vue?vue&type=script&lang=js"
export * from "./BottomAppBar.vue?vue&type=script&lang=js"
import style0 from "./BottomAppBar.vue?vue&type=style&index=0&id=c6fc6224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fc6224",
  null
  
)

export default component.exports